import { render, staticRenderFns } from "./OmxField.vue?vue&type=template&id=bbbf7b2e&scoped=true"
import script from "./OmxField.vue?vue&type=script&lang=js"
export * from "./OmxField.vue?vue&type=script&lang=js"
import style0 from "./OmxField.vue?vue&type=style&index=0&id=bbbf7b2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbf7b2e",
  null
  
)

export default component.exports